import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { ShippingMethodModel } from '../models/shipping-method.model';

export class ShippingMethodsApiService extends ApiService {
  static endpoint = 'shipping-methods';

  /**
   * @param {Number|null} shippingMethodId
   * @return {String}
   * @protected
   */
  static buildShippingMethodUrl(shippingMethodId = null) {
    return this.buildUrl(shippingMethodId);
  }

  /**
   * @param {String|Number} shippingMethodId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<ShippingMethodModel>>}
   * @public
   */
  static async get(shippingMethodId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildShippingMethodUrl(shippingMethodId), {
      ...config,
      dataModel: ShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} shippingMethodId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<ShippingMethodModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildShippingMethodUrl(), {
      ...config,
      dataModel: ShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<ShippingMethodModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildShippingMethodUrl(), data, {
      ...config,
      dataModel: ShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} shippingMethodId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<ShippingMethodModel>>}
   * @public
   */
  static async patch(shippingMethodId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildShippingMethodUrl(shippingMethodId), data, {
      ...config,
      dataModel: ShippingMethodModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} shippingMethodId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(shippingMethodId, config = {}) {
    return HttpApiClient.delete(this.buildShippingMethodUrl(shippingMethodId), { ...config });
  }
}
